/**
 * Registriert keys fuer die Uebersetzung, damit i18n.js sie nicht entfernt.
 *
 * Hinweis: Mit dem Typparameter kann der Typ der Keys eingeschraenkt werden, bspw. auf die Werte eines Enums, damit
 * der Compiler warnt, wenn der Key dort nicht (mehr) existiert.
 */
export function keysToTranslate<K>(keys: K[]): K[] {
  return keys;
}
